/**
 * @generated SignedSource<<b120ab8afd2ebf72d2b69ce03e4d4057>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventCompetitionsCarouselFragment$data = {
  readonly competitions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly competition: {
          readonly " $fragmentSpreads": FragmentRefs<"CompetitionCardFragment">;
        };
        readonly id: string;
      };
    }>;
  };
  readonly id: string;
  readonly slug: string;
  readonly " $fragmentType": "EventCompetitionsCarouselFragment";
};
export type EventCompetitionsCarouselFragment$key = {
  readonly " $data"?: EventCompetitionsCarouselFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCompetitionsCarouselFragment">;
};

import EventCompetitionsCarouselFragmentPaginationQuery_graphql from './EventCompetitionsCarouselFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "competitions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": EventCompetitionsCarouselFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "EventCompetitionsCarouselFragment",
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": "competitions",
      "args": null,
      "concreteType": "EventCompetitionConnection",
      "kind": "LinkedField",
      "name": "__EventCompetitionsCarouselFragment_competitions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventCompetitionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventCompetition",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Competition",
                  "kind": "LinkedField",
                  "name": "competition",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "CompetitionCardFragment"
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "614547bc2f782f918554c346e17b476d";

export default node;
